import React from "react";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { countGuests, GuestsInput } from "../../../../models/search";
import { searchbar } from "../../translations";
import { AgeCategory } from "@shared/models/article";
import "./guests.scss";

type Props = {
  max?: number,
  value?: GuestsInput,
  onChange?: (value?: GuestsInput) => void;
}

const SearchItemSelectorGuests = (
  {
    max = 12,
    value,
    onChange = () => void 0
  }: Props) => {

  const intl = useIntl();

  const onValueChange = (type: keyof GuestsInput, increment: 1 | -1) => {
    const newValue = {
      [AgeCategory.ADULT]: value?.ADULT || 0,
      [AgeCategory.CHILD]: value?.CHILD || 0,
      [AgeCategory.EXEMPT]: value?.EXEMPT ||0,
      [type]: (!!value && !!value[type] ? value[type] : 0) + increment
    };
    onChange(countGuests(newValue) === 0 ? undefined : newValue);
  }

  return (
    <dl className="guests-form">
      <dt>{intl.formatMessage(searchbar.guestsAdults)}</dt>
      <dd>
        <button type="button"
                disabled={!value || value?.ADULT === 0}
                onClick={() => onValueChange(AgeCategory.ADULT, -1)}>
          <FontAwesomeIcon icon={faMinus} />
        </button>
        <span>{value?.ADULT || 0}</span>
        <button type="button"
                disabled={countGuests(value) === max}
                onClick={() => onValueChange(AgeCategory.ADULT, 1)}>
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </dd>
      <dt>
        {intl.formatMessage(searchbar.guestsChildren)}
        <span>{intl.formatMessage(searchbar.guestsChildrenRange)}</span>
      </dt>
      <dd>
        <button type="button"
                disabled={!value || value?.CHILD === 0}
                onClick={() => onValueChange(AgeCategory.CHILD, -1)}>
          <FontAwesomeIcon icon={faMinus} />
        </button>
        <span>{value?.CHILD || 0}</span>
        <button type="button"
                disabled={countGuests(value) === max}
                onClick={() => onValueChange(AgeCategory.CHILD, 1)}>
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </dd>
      <dt>
        {intl.formatMessage(searchbar.guestsExempts)}
        <span>{intl.formatMessage(searchbar.guestsExemptsRange)}</span>
      </dt>
      <dd>
        <button type="button"
                disabled={!value || value?.EXEMPT === 0}
                onClick={() => onValueChange(AgeCategory.EXEMPT, -1)}>
          <FontAwesomeIcon icon={faMinus} />
        </button>
        <span>{value?.EXEMPT || 0}</span>
        <button type="button"
                disabled={countGuests(value) === max}
                onClick={() => onValueChange(AgeCategory.EXEMPT, 1)}>
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </dd>
    </dl>);

}

export default SearchItemSelectorGuests;
